import React, {Component} from "react";
import {withTranslation} from "react-i18next";

class KnoaToggle extends Component {
  constructor(prop) {
    super(prop);
  }

  render() {
    const {Name, onChange, value, labelId, disabled, onText, offText} = this.props;
    const {t} = this.props;

    return (
        <div className="toggle-switch">
          <input
              type="checkbox"
              role="switch"
              className="toggle-switch-checkbox"
              id={Name}
              name={Name}
              checked={value}
              aria-checked={value}
              onChange={onChange}
              aria-labelledby={labelId}
              disabled={disabled ? true : false}
          />
          <label className="toggle-switch-label" htmlFor={Name}>
            <span className="toggle-switch-inner" data-on={onText} data-off={offText} aria-hidden="true"/>
            <span className="toggle-switch-switch" aria-hidden="true"/>
          </label>
        </div>
    );
  }
}

export default withTranslation()(KnoaToggle);